import { useUserHasAdministrationRole } from '../../../hooks/use-user-role';
import { useHasExpiringApiKeys } from '../../../pages/settings/api-component/hooks/use-has-expiring-api-keys';
import { useHasDismissedBanner } from './use-has-dismissed-banner';

/**
 * Is the user an Admin
 * AND are any api keys set to expire within 30 days
 * AND has it been at least 24hrs since the banner was dismissed
 * @returns {boolean}
 */
export const useShouldShowApiKeysExpiringBanner = () => {
  const hasAdminRole = useUserHasAdministrationRole();
  const hasExpiringApiKeys = useHasExpiringApiKeys();
  const hasDismissedTheBannerInThePast24Hrs = useHasDismissedBanner();

  return hasAdminRole && hasExpiringApiKeys && !hasDismissedTheBannerInThePast24Hrs;
};
